import * as Layout from './Layout/Layout.css';
import * as Select from './Select/Select.css';
import * as Create from './Create/Create.css';
import * as Request from './Request/Request.css';
import * as ServiceSelectableCards from './ServiceSelectableCards/ServiceSelectableCards.css';

export default {
	Layout,
	Select,
	Create,
	Request,
	ServiceSelectableCards
};
